import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Typography,
  Card,
  Dropdown,
  Checkbox,
  message,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";
import FullPageLayout from "../../../shared-components/layout/FullPageLayout";
import { css } from "@emotion/css";
import { useSelector, useDispatch } from "react-redux";
import SettingsIcon from "../../../Icons/SettingsIcon";
import ArrowRightIcon from "../../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import PeopleOnLeave from "./components/PeopleOnLeave.js";
import MyColleagues from "./components/MyColleagues.js";
import ReferMaxCard from "./components/ReferMaxCard.js";
import NotificationCard from "./components/NotificationPanel.js";
import NeedHelp from "./components/NeedHelp.js";
import SearchBar from "../../../shared-components/layout/searchbar.js";
import {
  getAllowedAppsAction,
  getCompanyAppsAction,
  saveCompanyAppsAction,
  updateCompanyAppsLocal,
} from "../../../store/action/admin/companyAction";
import InputField from "./components/Inputfeild.js";

const { Text } = Typography;

const defaultImageMap = {
  People: "/DashboardImages/People.png",
  Forms: "/DashboardImages/Forms.png",
  Invoice: "/DashboardImages/Invoice.png",
  Documents: "/DashboardImages/Documents.png",
  Projects: "/DashboardImages/Projects.png",
  CRM: "/DashboardImages/CRM.png",
  Recruitment: "/DashboardImages/Recruitment.png",
  Performance: "/DashboardImages/Performance.png",
  AI: "/DashboardImages/AI.png",
  POS: "/DashboardImages/POS.png",
  Kiosk: "/DashboardImages/Kiosk.png",
  Training: "/DashboardImages/Training.png",
  Payroll: "/DashboardImages/Payroll.png",
  Expense: "/DashboardImages/Expense.png",
  Inventory: "/DashboardImages/Inventory.png",
  Sales: "/DashboardImages/Sales.png",
};
export const serviceLinks = (sharedUserInfo) => {
  let userType = "noUser";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }

  return [
    { name: "Invoice", href: process.env.REACT_APP_FE_INVOICE_URL },
    { name: "Projects", href: process.env.REACT_APP_FE_PROJECT_URL },
    { name: "People", href: process.env.REACT_APP_FE_HR_URL },
    { name: "Forms", href: process.env.REACT_APP_FE_FORM_BUILDER_URL },
    { name: "Performance", href: process.env.REACT_APP_FE_PERFORMANCE_URL },
    {
      name: "Payroll",
      href:
        process.env.REACT_APP_FE_HR_URL +
        `/${
          userType === "admin" ? userType : "manager"
        }/payroll/process-payroll/`,
    },
    {
      name: "Training",
      href:
        process.env.REACT_APP_FE_HR_URL +
        `/${userType === "admin" ? userType : "manager"}/grow/training/`,
    },
    {
      name: "Recruitment",
      href:
        process.env.REACT_APP_FE_HR_URL +
        `/${userType === "admin" ? userType : "manager"}/grow/job-posts/`,
    },
  ];
};
function Dashboard() {
  const dispatch = useDispatch();
  const [visibleApps, setVisibleApps] = useState({});
  const [imageMap, setImageMap] = useState({});

  const getCompanyAppsList = useSelector((state) => state.getCompanyAppsList);
  const { companyApps, companyAppsloading } = getCompanyAppsList;
  // const getAllowedAppsList = useSelector((state) => state.getAllowedAppsList);
  // const { allowedApps, allowedAppsloading } = getAllowedAppsList;

  //console.log({ allowedApps });
  useEffect(() => {
    if (companyApps) {
      const filteredApps = {};
      Object.keys(companyApps).forEach((app) => {
        // if (allowedApps.includes(app)) {
        filteredApps[app] = companyApps[app];
        // }
      });

      setVisibleApps(filteredApps);

      const filteredMap = {};
      Object.keys(defaultImageMap).forEach((app) => {
        if (filteredApps[app]) {
          filteredMap[app] = defaultImageMap[app];
        }
      });

      setImageMap(filteredMap);
    } else {
      setVisibleApps({});
      setImageMap({});
    }
  }, [companyApps]);

  const savePreferences = async (newPreferences) => {
    try {
      const filteredMap = {};
      Object.keys(defaultImageMap).forEach((app) => {
        if (newPreferences[app]) {
          filteredMap[app] = defaultImageMap[app];
        }
      });
      setImageMap(filteredMap);

      await dispatch(updateCompanyAppsLocal(newPreferences));
      await dispatch(saveCompanyAppsAction({ apps: newPreferences }));
    } catch (error) {
      message.error("Failed to save preferences");
    }
  };
  useEffect(() => {
    // if (!companyApps && !companyAppsloading) {
    //   dispatch(getCompanyAppsAction());
    // }
    // if (!allowedApps && !allowedAppsloading) {
    //   dispatch(getAllowedAppsAction());
    // }
  });

  const handleCheckboxChange = (app) => {
    const newPreferences = {
      ...visibleApps,
      [app]: !visibleApps[app],
    };
    setVisibleApps(newPreferences);
    savePreferences(newPreferences);
  };

  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const getToken =
    JSON.parse(localStorage.getItem("sharedUserInfo")) ||
    sharedUserInfo?.payload?.token;
  const getBrowserToken = JSON.parse(localStorage.getItem("browserToken"));
  const themeDefault = useSelector((state) => state.themeDefault);
  console.log(themeDefault);
  const primaryColor = themeDefault?.info?.colorPrimary;
  const border = themeDefault?.info?.newConfig?.cardborder;

  // Updated handleServiceClick function to use the array
  const handleServiceClick = (name) => {
    const service = serviceLinks(sharedUserInfo).find(
      (service) => service.name === name
    );
    if (service) {
      window.location.href = service.href;
    }
  };
  const [isVisible, setVisible] = useState(false);
  const [isMenuItem, setMenuItem] = useState("none");
  const [sidebarItems, setSidebarItems] = useState([]);

  const onCancel = () => {
    setVisible(false);
  };
  const styles = {
    container: css`
      min-height: 100vh;
    `,
    header: css`
      width: 100%;
      max-width: 1472px;
      margin-bottom: 16px;
    `,
    homeText: css`
      color: ${primaryColor};
      font-size: 24px;
    `,
    manageLayout: css`
      display: flex;
      align-items: center;
    `,
    manageText: css`
      color: #ffffff;
      font-size: 24px;
      border: none !important;

      &:hover {
        color: #ffffff !important;
        border: none;
        cursor: pointer;
      }

      &:focus {
        color: #ffffff;
      }
    `,
    settingsIcon: css`
      color: #ffffff;
      font-size: 24px;
    `,
    servicesGrid: css`
      display: ${Object.keys(imageMap).length === 0 ? "none" : "flex"};
      max-width: 1472px;
      padding: 20px;
      border-top: ${border};
    `,
    serviceItem: css`
      text-align: center;
      text-decoration: none;
      color: inherit;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    `,
    serviceImage: css`
      height: 82px;
      width: 82px;
      margin-bottom: 25px;
      object-fit: contain;
    `,
    serviceName: css`
      // color: #ffffff;
      font-size: 16px;
      white-space: nowrap;
    `,
    mainContent: css`
      max-width: 1472px;
      margin-top: 16px;
    `,
    peopleOnLeaveCard: css`
      width: 100%;
      height: 416px;
      margin-top: 16px;
    `,
    leaveTitle: css`
      margin-bottom: 16px !important;
    `,
    settingsDropdown: css`
      background: ${themeDefault?.info?.newConfig
        ?.PopoverBackgroundAccentSolidColor}08;
      backdrop-filter: blur(100px);
      -webkit-backdrop-filter: blur(100px);
      box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
        0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      padding: 24px;
      min-width: 200px;
    `,
    settingsTitle: css`
      margin-bottom: 12px;
    `,
    checkboxContainer: css`
      display: flex;
      flex-direction: column;
      max-height: 350px;
      overflow-y: auto;
    `,
    checkboxItem: css`
      padding: 6px 0;
      color: #ffffff;
    `,
  };

  // const widgetSettingsMenu = (
  //   <div className={styles.settingsDropdown}>
  //     <div className={styles.settingsTitle}>
  //       <Text>Widgets</Text>
  //     </div>
  //     <div className={styles.checkboxContainer}>
  //       {allowedApps &&
  //         allowedApps.length > 0 &&
  //         allowedApps.map((app) => (
  //           <div key={app} className={styles.checkboxItem}>
  //             <Checkbox
  //               checked={visibleApps[app]}
  //               onChange={() => handleCheckboxChange(app)}
  //               size="small"
  //             >
  //               {app}
  //             </Checkbox>
  //           </div>
  //         ))}
  //     </div>
  //   </div>
  // );
  const [selectedWidgets, setSelectedWidgets] = useState([
    "PeopleOnLeave",
    "MyColleagues",
    "ReferMaxCard",
    "NotificationCard",
    "NeedHelp",
  ]);

  const onCheck = (checkedKeys) => {
    setSelectedWidgets(checkedKeys);
  };

  return (
    <Row style={{ display: "flex" }}>
      {themeDefault?.loading ||
      companyAppsloading ||
      (themeDefault?.info?.status &&
        themeDefault?.info?.status === "loading") ||
      !themeDefault?.info?.newConfig ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <img src="/Loader1.gif" height="60%" />
        </div>
      ) : (
        <FullPageLayout name="Dashboard">
          <div className={styles.container}>
            {/* Header Section */}
            <Row
              justify="space-between"
              align="middle"
              className={styles.header}
            >
              <Text className={styles.homeText}>Dashboard</Text>
              {/* <div className={styles.manageLayout}> 
                <Dropdown
                  overlay={widgetSettingsMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <Button
                    type="link"
                    style={{
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                      fontWeight: 500,
                    }}
                  >
                    Manage Widgets <SettingsIcon size={16} />
                  </Button>
                </Dropdown>
              
              </div> */}
            </Row>

            {/* Services Icons Section */}
            <Card title="All Apps">
              <Row gutter={[16, 16]} className={styles.servicesGrid}>
                {Object.entries(imageMap).map(([name, src]) => (
                  <Col key={name} xs={12} sm={8} md={6} lg={4} xl={3}>
                    <div
                      className={styles.serviceItem}
                      onClick={() => handleServiceClick(name)}
                    >
                      <img
                        src={src}
                        alt={name}
                        className={styles.serviceImage}
                      />
                      <Text className={styles.serviceName}>{name}</Text>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card>

            {/* Rest of the component remains the same */}
            {/* Ask Max Input Section */}
            {/* <InputField /> */}
            {/* <Row
              className={css`
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 20px;
              `}
            >
              <Col xs={24} sm={22} md={20} lg={18} xl={16}>
                <SearchBar fromDrawer onCancel={onCancel} />
              </Col>
            </Row> */}
            {/* Main Content Section */}
            <Row gutter={16} className={styles.mainContent}>
              {/* Left Section */}
              <Col span={16}>
                {/* First Row: MyColleagues and ReferMaxCard */}
                <Row>
                  <Col xs={24} md={12} style={{ paddingRight: 8 }}>
                    {selectedWidgets.includes("MyColleagues") && (
                      <MyColleagues />
                    )}
                  </Col>
                  <Col xs={24} md={12} style={{ paddingLeft: 8 }}>
                    {selectedWidgets.includes("ReferMaxCard") && (
                      <ReferMaxCard />
                    )}
                  </Col>
                </Row>

                {/* Second Row: People on Leave Table */}
                <Row gutter={[16]}>
                  <Col span={24}>
                    {selectedWidgets.includes("PeopleOnLeave") && (
                      <Card
                        title={`People on leave`}
                        className={styles.peopleOnLeaveCard}
                      >
                        <PeopleOnLeave />
                      </Card>
                    )}
                  </Col>
                </Row>
              </Col>

              {/* Right Section */}
              <Col span={8}>
                <Row gutter={[]}>
                  <Col span={24}>
                    {selectedWidgets.includes("NeedHelp") && <NeedHelp />}
                  </Col>
                  <Col span={24}>
                    {selectedWidgets.includes("NotificationCard") && (
                      <NotificationCard />
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </FullPageLayout>
      )}
    </Row>
  );
}

export default Dashboard;
